// MOFO Program Variables
export const mofoVariables: any = {
    programTitle: "Morrison & Foerster LLP",
    effectiveDates: "9/01/2023 - 9/01/2024",
    feeDisclaimer: "All Premiums are subject to 3% California Surplus Lines Tax and 0.18% Stamping Fee (not included in below premiums).",
    EL_Items: [
        "MOFO_EL_Header",
        ["MOFO_EL_1M", "$1,000,000", "$712"],
        ["MOFO_EL_2M", "$2,000,000", "$924"],
        ["MOFO_EL_3M", "$3,000,000", "$1,080"],
        ["MOFO_EL_5M", "$5,000,000", "$1,341"],
        ["MOFO_EL_10M", "$10,000,000*", "$2,408"],
        ["MOFO_EL_15M", "$15,000,000**", "$5,561"],
        ["MOFO_EL_25M", "$25,000,000**", "$11,254"]
    ],
    EL_Disclaimers: [
        "<strong>*</strong>The maximum limit of liability for any participants without their underlying home and auto insurance policies in place with Chubb.",
        `<strong>**</strong>It is a requirement that any participant who <u>newly elects or enrolls</u> at these limits have their underlying home and auto insurance policies in place with Chubb and complete the Group Personal Excess Participants Questionnaire.  These limits are subject to prior underwriting approval.  These requirements have been waived for current participants renewing at their expiring limit.`
    ],
    UM_Items: [
        "MOFO_UM_Header",
        ["MOFO_UM_1M", "$1,000,000", "Included above"],
        ["MOFO_UM_2M", "$2,000,000", "$197"],
        ["MOFO_UM_3M", "$3,000,000", "$362"],
        ["MOFO_UM_5M", "$5,000,000", "$677"]
    ],
    UM_Disclaimers: ["*Please note that the UM/UIM limit cannot be higher than the liability limit."],
    EPLI_Items: [
        "MOFO_EP_Header",
        ["MOFO_EP_Decline", "By selecting this box, I am declining EPLI Insurance."],
        ["MOFO_EP_250K", "$250,000 per occurrence / $500,000 aggregate*", "$10,000", "$789"],
        ["MOFO_EP_500K", "$500,000 per occurrence / $500,000 aggregate*", "$10,000", "$1,183"],
    ],
    EPLI_Disclaimer: "<strong>*</strong>Any participant who <u>elects</u> this coverage is required to complete the Chubb Employment Practice Liability Coverage Request Worksheet.",
    CI_Items: [
        "MOFO_PR_Parent",
        "MOFO_PR_Yes",
        "MOFO_PR_No"
    ],
};

